import { clsx } from "clsx";
import { type PropsWithChildren, type ReactNode } from "react";

import style from "./styles/Dashboard.module.scss";

export interface ISideBarProps {
  open: boolean;
  position: "left" | "right";
}

function SideBar(props: PropsWithChildren<ISideBarProps>): ReactNode {
  return (
    <div
      className={clsx(style.sideBar, {
        [style.left]: props.position === "left",
        [style.right]: props.position === "right",
        [style.open]: props.open,
        [style.closed]: !props.open,
      })}
    >
      {props.children}
    </div>
  );
}

export default SideBar;
